import { useContext } from 'react';

import { HeatingAssistantContext } from '@/context/heatingAssistantContext';

export const useHeatingAssistantContext = () =>
  useContext(HeatingAssistantContext);
